import axios from "axios";

/**
 * Quantum Coin address validator.
 * https://raw.githubusercontent.com/quantumcoinproject/quantum-coin-js-sdk/refs/heads/main/index.js
 */

export default {
    async isValidAddress(address, currency, opts = {}) {
        if (address === null) {
            return false;
        }
        
        if (address.length !== 66) {
            return false;
        }

        const url = "https://sdk.readrelay.quantumcoinapi.com" + "/account/" + address;
        try {
            const response = await axios.get(url);
            return response.data && response.data.result.balance !== undefined;
        } catch (error) {
            return false;
        }
    },
};
